//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed, reactive, useRouter, useContext, onMounted } from '@nuxtjs/composition-api';
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfInput from "~/themes/fiskarsMoominDefault/components/components/atoms/SfInput/SfInput.vue";
import { validateEmail, markFieldAsTouched, touchedState } from '~/helpers/validation-utils';
import { useUserAccount } from "~/composables";
import { CMSNotificationType, extractCMSNotificationMessage } from "~/helpers/extractCMSNotificationMessage";
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import { AttemptType } from "~/helpers/analytics/types";
import { useVSFContext } from "@vue-storefront/core";
import { datadogLogs } from '@datadog/browser-logs'

export default {
  name: "LoginForm",
  components: {
    SfInput,
    SfButton,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false
    },
    formLabel: {
      type: String,
    },
    formDescription: {
      type: String,
    },
    emailLabel: {
      type: String,
    },
    emailPlaceholder: {
      type: String,
    },
    emailErrorMessage: {
      type: String,
    },
    emailFormatErrorMessage: {
      type: String,
    },
    passwordLabel: {
      type: String,
    },
    passwordPlaceholder: {
      type: String,
    },
    passwordErrorMessage: {
      type: String,
    },
    submitButton: {
      type: String,
    },
    captchaText: {
      type: String,
    },
    forgotpasswordtext: {
      type: String,
    },
    forgotpasswordlink: {
      type: String,
    },
    error: {
      type: Object,
      default: () => ({})
    },
    success: {
      type: Object,
      default: () => ({})
    },
  },
  mounted() {
    this.$nextTick(() => {
      const container = document.getElementById('loginform');

      if (container) {
        container.addEventListener('click', (event) => {

          const dataType = event.target.getAttribute('data-type');

          if (dataType !== null && dataType === 'internal') {
            this.$emit('toggleSignupModel');
            event.preventDefault();
            return false;
          }
        });
      }
    });
  },
  setup(props, {emit}) {
    const router = useRouter();
    const { login: loginUser, loading, recaptchaFlag } = useUserAccount();
    const loginError = ref('');
    const email = ref('');
    const password = ref('');
    const { i18n } = useContext();
    const { localePath } = useVSFContext();
    const captchaCheckInprogress = ref(false);

    onMounted(() => {
      const targetElement = document.body;
      const observerConfig = {
        childList: true,
        attributes: false,
        attributeOldValue: false,
        characterData: false,
        characterDataOldValue: false,
        subtree: false
      };
      const reCaptchaObserver = new MutationObserver(DOMChangeCallbackFunction);
      reCaptchaObserver.observe(targetElement, observerConfig);
    })

    const DOMChangeCallbackFunction = (mutationRecords) => {
      const timerInit = setInterval(() => {
        mutationRecords.forEach((mutationRecord) => {
          if (mutationRecord.addedNodes.length) { //check only when notes were added to DOM
                var reCaptchaParentContainer = mutationRecord.addedNodes[0];
                var reCaptchaIframe = reCaptchaParentContainer.querySelectorAll('iframe[title*="recaptcha"]');

                if(reCaptchaIframe && reCaptchaIframe.length === 1) {
                  const abc = window.getComputedStyle(reCaptchaParentContainer).getPropertyValue("opacity");
                  const visibility = window.getComputedStyle(reCaptchaParentContainer).getPropertyValue("visibility");
                  if (parseInt(abc) == 1 && visibility == "visible") {
                    captchaCheckInprogress.value = true;
                  } else {
                    captchaCheckInprogress.value = false;
                  }
                }
            }
        });
      }, 1000);
  }

    const submit = async () => {
      if(!canSubmit.value) return false

      try {
        const data = {
          email: email.value,
          password: password.value,
        }

        const response = await loginUser(data);

        if(response?.status === 200){
          analyticsEvents.signedIn(AttemptType.SUCCESS)
          if(props.isModal)
            emit('loggedIn', response)
          else
            router.push(localePath(i18n.t('PAGES.PERSONAL_DETAILS')));
        } else {
          analyticsEvents.signedIn(AttemptType.FAILURE)
          const cmsErrorMessage = extractCMSNotificationMessage(props.error, CMSNotificationType.ERROR, response?.errorCode);
          updateLoginError(cmsErrorMessage || response?.message || props.passwordErrorMessage || 'Login error');
        }

      } catch (error) {
        datadogLogs.logger.error('Error:', error);
      }
    }

    const btnFlag = computed(() => {
      if (captchaCheckInprogress.value) {
        return false
      }
      else if (!captchaCheckInprogress.value && loading.value) {
        return false
      }
      else {
        return true
      }

      // return !loading.value
    });

    //can submit form
    const canSubmit = computed(() => !!(password.value.length && formValues.email.validation?.valid && btnFlag.value));

    const formValues = reactive({
      email: {
        label: props.emailLabel,
        placeholder: props.emailPlaceholder,
        touched: touchedState(email.value),
        value: () => email.value,
        validation: computed(() => {
          if (!formValues.email.touched) return { valid: true, error: "" };
          const result = validateEmail(email.value, props.emailLabel);
          return {
            valid: result.isValid,
            error: result.isValid ? "" : result.errorMessage || props.emailErrorMessage,
          };
        }),
        input: () => updateLoginError()
      },
      password: {
        label: props.passwordLabel,
        placeholder: props.passwordPlaceholder,
        touched: touchedState(password.value),
        value: () => password.value,
        validation: computed(() => {
          if (!formValues.password.touched) return { valid: true, error: "" };
          return {
            valid: password.value.length > 0 && !loginError.value,
            error: password.value.length
              ? loginError.value
              : props.passwordErrorMessage,
          };
        }),
        input: () => updateLoginError()
      },
    });

    const updateLoginError = (errorMsg = '') => loginError.value = errorMsg;

    return {
      email,
      password,
      submit,
      canSubmit,
      formValues,
      markFieldAsTouched,
      loginError,
      captchaCheckInprogress,
      recaptchaFlag
    }
  },
};
